var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/abstract-api.request.ts
var ApiRequestMethod = /* @__PURE__ */ function(ApiRequestMethod2) {
  ApiRequestMethod2["GET"] = "GET";
  ApiRequestMethod2["POST"] = "POST";
  ApiRequestMethod2["DELETE"] = "DELETE";
  ApiRequestMethod2["PUT"] = "PUT";
  return ApiRequestMethod2;
}({});
var _AbstractApiRequest = class _AbstractApiRequest {
  constructor() {
    /**
    * JWT token required
    */
    __publicField(this, "isPrivate", false);
    /**
    * Available only from client side
    */
    __publicField(this, "clientOnly", false);
  }
  // readonly responseBody: D; // never used but needed for define the response data type on the fly
  /**
  * @example
  * For url 'host.com/api/some_path'.
  * getApiUrl() {
  *     return 'host.com/api';
  *   }
  *
  * If getApiUrl is not override then getApiUrl is taken from configAdapter. See interface IApiServiceAdapter
  */
  getApiUrl() {
    return null;
  }
  /**
  * @example
  * For url '/some_path/:userId/user';
  * getUrlParams() {
  *   return { userId: '123' }
  * }
  */
  getUrlParams() {
    return {};
  }
  /**
  * @example
  * For url '/some_path/?parameter=1';
  * getParams() {
  *   return { parameter: 1 }
  * }
  */
  getQueryParams() {
    return null;
  }
  getBody() {
    return null;
  }
  getHeaders() {
    return null;
  }
  /* Data mapper method */
  prepareResponse(data) {
    return data;
  }
};
__name(_AbstractApiRequest, "AbstractApiRequest");
var AbstractApiRequest = _AbstractApiRequest;

// src/request/application/post-application-cancel.request.ts
var _PostApplicationCancelRequest = class _PostApplicationCancelRequest extends AbstractApiRequest {
  constructor(applicationUuid) {
    super();
    __publicField(this, "applicationUuid");
    __publicField(this, "method");
    __publicField(this, "url");
    __publicField(this, "isPrivate");
    this.applicationUuid = applicationUuid, this.method = ApiRequestMethod.POST, this.url = "/api/application/:application_uuid/cancel", this.isPrivate = true;
  }
  getUrlParams() {
    return {
      application_uuid: this.applicationUuid
    };
  }
};
__name(_PostApplicationCancelRequest, "PostApplicationCancelRequest");
var PostApplicationCancelRequest = _PostApplicationCancelRequest;
export {
  PostApplicationCancelRequest
};
//# sourceMappingURL=post-application-cancel.request.mjs.map